export default __webpack_public_path__ + "static/media/link.88b7b754.png";